import * as React from "react";
import { TextInput, SelectInput, NumberInput, DateTimeInput, Create, required } from "react-admin";
import { Grid } from "@mui/material";
import {
  PromotionAmountTypeEnum,
  PromotionTypeEnum,
  StatusEnum,
} from "../../common/enum";
import Transformer from "../../common/Transformer";
import { SimpleForm} from "src/enterprise/ra-rbac";
import { PromotionCreateComponent } from "./PromotionComponent";

export const PromotionCreate = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {
        fromDate:
          typeof data["from_date"] === "string" ||
          typeof data["from_date"] === "undefined"
            ? data["from_date"]
            : (data["from_date"] as Date).toISOString(),
        toDate:
          typeof data["to_date"] === "string" ||
          typeof data["to_date"] === "undefined"
            ? data["to_date"]
            : (data["to_date"] as Date).toISOString(),
      },
    });
    return data;
  };
  return (
    <Create transform={transform} component={PromotionCreateComponent}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} md={4}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} md={4}>
            <TextInput source="description" />
          </Grid>
          <Grid item sm={12} md={4}>
            <TextInput source="code" validate={required()} />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput validate={required()} source="status" choices={StatusEnum} />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput
              validate={required()}
              source="type"
              choices={PromotionTypeEnum}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <NumberInput
              validate={required()}
              source="amount"
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput
              validate={required()}
              source="amount_type"
              choices={PromotionAmountTypeEnum}
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput validate={required()} source="from_date"/>
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput validate={required()} source="to_date"/>
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput disabled source="created_at"/>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
